import { useState, useEffect } from 'react';

export interface SchedulingProScriptProps {
    dataApiKey: string;
    schedulerId: string;
    scriptUrl: string;
}

export function useLoadSchedulingProScript(props: SchedulingProScriptProps) {
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = useState(false);
    const schedulerObjectInitialized = useSchedulerObjectInitialized();

    useEffect(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = props.scriptUrl;
        scriptTag.id = 'se-widget-embed';
        scriptTag.setAttribute('data-api-key', props.dataApiKey);
        scriptTag.setAttribute('data-schedulerid', props.schedulerId);
        scriptTag.defer = true;
        scriptTag.onload = () => setScriptLoadedSuccessfully(true);
        scriptTag.onerror = () => setScriptLoadedSuccessfully(false);

        document.body.appendChild(scriptTag);

        return () => {
            document.body.removeChild(scriptTag);
        };
    }, [props.dataApiKey, props.schedulerId, props.scriptUrl, schedulerObjectInitialized]);

    return scriptLoadedSuccessfully;
}

export function useSchedulerObjectInitialized() {
    const [schedulerObjectInitialized, setSchedulerObjectInitialized] = useState(false);

    useEffect(() => {
        const checkDelay = 250;
        const checkTimeout = 30 * 1000; // 30 seconds
        // Check if the scheduler object is initialized
        const interval = setInterval(() => {
            if (window._scheduler) {
                setSchedulerObjectInitialized(true);
                clearInterval(interval);
                clearTimeout(timeout);
            }
        }, checkDelay);

        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, checkTimeout);

        return () => clearInterval(interval);
    }, []);

    return schedulerObjectInitialized;
}
